import DashboardNotifications from './DashboardNotifications';
import React from 'react';
import Invoices from './brand/Invoices';
import ExpiringLicenses from './brand/ExpiringLicenses';

export default function BrandDashboard() {
  return (
    <div className="grid grid-cols-3 gap-x-7">
      <div className="col-span-2">
        <Invoices/>
        <div className="grid grid-cols-2 gap-x-4">
          <ExpiringLicenses/>
        </div>
      </div>
      <div>
        <DashboardNotifications/>
      </div>
    </div>
  );
}
